/** The existing plans page, where a brand without a subscription takes a paid plan. */
export const PLANS_PAGE = '/dashboard?paywall=plans';
